import { render, staticRenderFns } from "./CSRMenu.vue?vue&type=template&id=9ec50c50&"
import script from "./CSRMenu.vue?vue&type=script&lang=ts&"
export * from "./CSRMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports